import actionTypes from '../constants/action-types';

const block = () => ({
  type: actionTypes.BLOCK,
});

export default block;
